<template>
  <div class="tile">
    <div class="tile is-parent">
      <article class="tile is-child detail-page-tile">
        <div>
          <draggable
            :list="imagesWithInfo"
            group="imagesWithInfo"
            class="is-flex columns is-multiline dragable-box"
            @change="event => onImageOrderChange(categoryId, event)"
            handle=".item-drag-handle"
          >
            <div
              v-for="(image, index) in imagesWithInfo"
              :key="image.quoteImageId"
              class="is-flex column is-narrow p-2 item-drag"
            >
              <div v-if="image.imageContent" 
                :class="'card'">
                <header class="card-header-line">
                  <div class="card-header-title p-2 has-background-light">
                    <div class="is-flex columns is-gapless" 
                      style="width: 100%">
                      <div class="is-flex column is-narrow">
                        <a class="has-text-danger is-outlined" 
                          @click="showDeleteModal(image.quoteImageId)">
                          <span class="icon">
                            <i class="mdi mdi-delete mdi-24px" 
                              aria-hidden="true" />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </header>
                <div class="card-image">
                  <a @click="viewImage(index)">
                    <figure class="image is-128x128">
                      <div style="position: relative">
                        <i
                          v-if="image.isPrimary"
                          class="mdi mdi-star mdi-24px has-text-gold"
                          style="position: absolute; z-index: 1"
                        />
                        <img
                          v-if="image.imageContent"
                          class="image is-128x128"
                          style="object-fit: cover;"
                          :src="image.imageContent"
                          :key="image.quoteImageId"
                          :id="image.quoteImageId"
                        />
                      </div>
                    </figure>
                  </a>
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </article>
    </div>
    <confirm-modal
      :active.sync="isConfirmModalActive"
      @ok="deleteImage(true)"
      @cancel="deleteImage(false)"
      :ok-text="'Yes'"
      :cancel-text="'No'"
    >
      <p slot="text-title">Delete image</p>
      <p slot="text-content">
        Image will be deleted. Continue?
      </p>
    </confirm-modal>
    <bulma-carousel-modal v-if="isCarouselModalActive"
      :image-width="800"
      :image-height="600"
      :active.sync="isCarouselModalActive"
      :image-ids="imageIds"
      :start-index="carouselStartIndex"
      @close="closeCarousel" />
  </div>
</template>

<script>
import MobileImageUploaderService from '../mobileimageuploader/MobileImageUploaderService'
import draggable from 'vuedraggable'
import ConfirmModal from '../../components/BulmaModal/ConfirmModal.vue'
import BulmaCarouselModal from '../mobileimageuploader/BulmaCarousel/BulmaCarouselModal.vue'
export default {
  name: 'MobileImageViewer',
  components: {
    draggable,
    ConfirmModal,
    BulmaCarouselModal
  },
  props: {
    quoteId: {
      type: String
    },
    categoryId: {
      type: String
    },
    
    imagesWithInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      size: 200,
      selectedImageId: '',
      imageIds: null,
      isConfirmModalActive: false,
      isCarouselModalActive: false,
      carouselStartIndex: 0
    }
  },
  watch: {
    imagesWithInfo(value) {
      const imageIds = this.imagesWithInfo.map((i) => i.quoteImageId)
      this.imageIds = imageIds
    }
  },
  created() {},
  methods: {
    showDeleteModal(id) {
      this.selectedImageId = id
      this.isConfirmModalActive = true
    },
    async deleteImage(confirm) {
      this.isConfirmModalActive = false
      if (confirm) {
        await MobileImageUploaderService.deleteImage(this.selectedImageId)
        const index = this.imageIds.indexOf(this.selectedImageId)
        this.imageIds.splice(index, 1)
        const indexToRemove = this.imagesWithInfo.findIndex(i => i.quoteImageId === this.selectedImageId)
        this.imagesWithInfo.splice(indexToRemove, 1)
        // this.$notification.openNotificationWithType('success', 'Delete images', 'image deleted')
        this.$toast.open({
            message: 'image deleted',
            type: 'is-success',
            position: 'is-top',
            queue: false,
            duration: 5000
        })
        this.$emit('update-image')
      }
      this.selectedImageId = ''
    },
    async viewImage(index) {
      this.$showSpinner()
      this.carouselStartIndex = index
      this.isCarouselModalActive = true
      this.$hideSpinner()
    },
    closeCarousel() {
      this.isCarouselModalActive = false
    }
  }
}
</script>
